function handleAnalyticsClick(productId, url) {
  nostojs((api) => {
    api.recordSearchClick("autocomplete", {
      productId: productId,
      url: url,
    });
  });
}

class MobileSearch extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["results"];
  }

  static get requiredExternalElements() {
    return ["input", "form", "submit", "reset"];
  }

  setupListeners() {
    super.setupListeners();

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleReset = this.handleReset.bind(this);

    this.listeners.add(
      this.externalEls.form.element,
      "submit",
      this.handleFormSubmit,
    );
    this.listeners.add(
      this.externalEls.input.element,
      "input",
      this.handleInput,
    );
    this.listeners.add(
      this.externalEls.input.element,
      "focus",
      this.handleFocus,
    );
    this.listeners.add(this.externalEls.input.element, "blur", this.handleBlur);
    this.listeners.add(
      this.externalEls.reset.element,
      "click",
      this.handleReset,
    );

    // Initial icon state check in case there's a preset value
    this.toggleIcons(this.externalEls.input.element.value.trim().length > 0);
  }

  handleFormSubmit(event) {
    if (!this.externalEls.input.element.value.trim().length) {
      event.preventDefault();
    }
  }

  handleInput() {
    const input = this.externalEls.input.element;
    const value = input.value.trim();

    this.toggleIcons(value.length > 0);
    this.getSearchResults(value);

    if (!value.length) {
      input.value = "";
    }
  }

  handleFocus() {
    this.toggleIcons(true);
  }

  handleBlur() {
    if (!this.externalEls.input.element.value.trim().length) {
      this.toggleIcons(false);
    }
  }

  handleReset(event) {
    event.preventDefault();
    event.stopPropagation();

    this.externalEls.input.element.value = "";
    this.externalEls.input.element.focus();
    this.toggleIcons(false);
  }

  toggleIcons(showReset) {
    if (showReset) {
      this.externalEls.submit.element.style.display = "none";
      this.externalEls.reset.element.style.display = "block";
    } else {
      this.externalEls.submit.element.style.display = "block";
      this.externalEls.reset.element.style.display = "none";
      this.resetMobileSearchResults();
    }
  }

  getQuery() {
    return this.externalEls.input.element.value.trim();
  }

  getSearchResults(searchTerm) {
    if (searchTerm && searchTerm.length > 2) {
      this.nostoMobileSearch(searchTerm);
    } else {
      this.resetMobileSearchResults();
    }
  }

  nostoMobileSearch(searchTerm) {
    nostojs((api) => {
      api
        .search(
          {
            query: searchTerm,
            products: {
              fields: [
                "name",
                "pid",
                "alternateImageUrls",
                "thumbUrl",
                "url",
                "brand",
                "productId",
                "categories",
                "price",
                "listPrice",
                "imageUrl",
                "inventoryLevel",
                "customFields.key",
                "customFields.value",
                "skus.inventoryLevel",
                "skus.name",
                "skus.id",
                "priceCurrencyCode",
              ],
              size: 4,
            },
            keywords: { fields: ["keyword"], size: 3 },
          },
          {
            track: "autocomplete",
          },
        )
        .then((response) => {
          const products = response.products.hits;
          const keywords = response.keywords.hits;

          if (products.length) {
            this.renderProducts(products, searchTerm, keywords);
          }
          if (keywords.length) {
            this.renderKeywords(keywords);
          }
          if (keywords.length === 0 && products.length === 0) {
            this.resetMobileSearchResults();
            return;
          }

          this.fetchShopifyPredictiveAPI(searchTerm);
          this.openMobileSearchResults();
        })
        .catch((error) => {
          if (error?.code === 20) {
            return;
          }
          this.toggleIcons(
            this.externalEls.input.element.value.trim().length > 0,
          );
        });
    });
  }

  renderProducts(products, searchTerm, keywords) {
    const resultsEl = this.els.results.element;
    if (resultsEl) resultsEl.innerHTML = "";

    if (this.els["result-term"]?.exists) {
      this.els["result-term"].element.innerHTML = "";
    }

    const viewAllAnchor = this.querySelector(
      ".header-search_right .header-search_view_all a",
    );

    let autoComplete = "";
    if (keywords.length) {
      autoComplete = keywords[0].keyword;
    } else {
      autoComplete = searchTerm;
    }

    let newMatchInnerHTML = false;
    let newHrefValue = false;
    let newAutoCompleteHref = false;

    if (autoComplete) {
      newMatchInnerHTML = autoComplete;
      newHrefValue = `/search?q=${encodeURIComponent(autoComplete)}`;
      newAutoCompleteHref = `/search?q=${encodeURIComponent(autoComplete)}`;
    }

    if (this.els["result-term"]?.exists && newMatchInnerHTML) {
      this.els["result-term"].element.innerHTML = newMatchInnerHTML;
    }
    if (this.els["result-anchor"]?.exists && newAutoCompleteHref) {
      this.els["result-anchor"].element.href = newAutoCompleteHref;
    }
    if (viewAllAnchor && newHrefValue) {
      viewAllAnchor.href = newHrefValue;
    }

    products.forEach((product, index) => {
      const item = document.createElement("div");
      item.classList.add("result-item");

      const productBadge = this.productBadge(product, index);

      const altImageUrl =
        product.alternateImageUrls && product.alternateImageUrls[0] ?
          product.alternateImageUrls[0]
        : "";

      item.innerHTML = `
        <div class="product-card-media-container">
          <a href="${product.url}" class="product-link main" onclick="handleAnalyticsClick('${product.productId}', '${product.url}')">
            <h2 class="product-badge-rd">${productBadge}</h2>
            <img class="item-image" src="${product.imageUrl}" data-alt-image="${altImageUrl}" alt="${product.name}">
          </a>
          <button
            type="button"
            class="prd-Card_QuickBuy"
            data-quick-buy-external-el="trigger"
            data-producturl="${product.url}"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5 15H3V6H14V7.5" stroke="#131313" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13 10V18" stroke="#131313" stroke-linecap="round"/>
              <path d="M9 14L17 14" stroke="#131313" stroke-linecap="round"/>
              <path d="M6 8V4.5C6 3.11929 7.11929 2 8.5 2C9.88071 2 11 3.11929 11 4.5V8" stroke="#131313" stroke-linecap="round"/>
            </svg>
            <span class="util-ScreenReaderOnly">Quick buy</span>
          </button>
        </div>
        <div class="product-info-wrapper">
          <a href="${product.url}" class="product-link main"></a>
          <div class="product-name">
            <a class="product-name_link" href="${product.url}" title="Go to Product: ">${product.name}</a>
          </div>
          <a class="product-subtitle-wrapper" href="${product.url}" title="Go to Product: ">
            <div class="product-subtitle line-clamp">${getCustomField(product, "producttype")}</div>
          </a>
          <div class="product-pricing">
            <div class="pricing">
              ${this.getPriceSpan(product)}
            </div>
          </div>
        </div>`;

      const h2Element = item.querySelector(".product-badge-rd");
      if (!productBadge || productBadge.trim() === "") {
        h2Element.remove();
      }

      resultsEl.appendChild(item);
    });
  }

  fetchShopifyPredictiveAPI(searchTerm) {
    fetch(
      `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const collectionList = suggestions.resources.results.collections;
        const pageList = suggestions.resources.results.pages;

        if (collectionList.length > 0) {
          this.renderCategory(collectionList);
        }
        if (pageList.length > 0) {
          this.renderPages(pageList);
        }
      });
  }

  renderCategory(categories) {
    const parentDiv = this.querySelector(
      ".header-search_group.categories ul.header-search_list",
    );
    if (!parentDiv) return;

    parentDiv.innerHTML = "";

    categories.forEach((item) => {
      const li = document.createElement("li");
      li.classList.add("header-search_item");

      const a = document.createElement("a");
      a.classList.add("header-search_link");
      a.setAttribute("href", item.url);
      a.setAttribute("title", item.title);
      a.textContent = item.title;

      li.appendChild(a);
      parentDiv.appendChild(li);
    });
  }

  renderKeywords(keywords) {
    const parentDiv = this.querySelector(
      ".header-search_group.keywords ul.header-search_list",
    );
    if (!parentDiv) return;

    parentDiv.innerHTML = "";

    keywords.slice(1).forEach((item) => {
      const li = document.createElement("li");
      li.classList.add("header-search_item");

      const a = document.createElement("a");
      a.classList.add("header-search_link");
      a.setAttribute("href", `/search?q=${item.keyword}`);
      a.setAttribute("title", item.keyword);
      a.textContent = item.keyword;

      li.appendChild(a);
      parentDiv.appendChild(li);
    });
  }

  renderPages(pages) {
    const parentDiv = this.querySelector(
      ".header-search_group.pages ul.header-search_list",
    );
    if (!parentDiv) return;

    parentDiv.innerHTML = "";

    pages.forEach((item) => {
      const li = document.createElement("li");
      li.classList.add("header-search_item");

      const a = document.createElement("a");
      a.classList.add("header-search_link");
      a.setAttribute("href", item.url);
      a.setAttribute("title", item.title);
      a.textContent = item.title;

      li.appendChild(a);
      parentDiv.appendChild(li);
    });
  }

  resetMobileSearchResults() {
    const navigation = document.querySelector(
      "#menu-drawer .menu-drawer__navigation",
    );
    const utilityLinks = document.querySelector(
      "#menu-drawer .menu-drawer__utility-links",
    );

    if (navigation) navigation.classList.remove("hidden");
    if (utilityLinks) utilityLinks.classList.remove("hidden");

    this.classList.remove("open");

    if (this.els.results?.exists) {
      this.els.results.element.innerHTML = "";
    }
    if (this.els["result-term"]?.exists) {
      this.els["result-term"].element.innerHTML = "";
    }

    const resultListGroups = this.querySelectorAll(
      ".header-search_groups .header-search_group ul.header-search_list",
    );
    resultListGroups.forEach((element) => {
      element.innerHTML = "";
    });
  }

  openMobileSearchResults() {
    const navigation = document.querySelector(
      "#menu-drawer .menu-drawer__navigation",
    );
    const utilityLinks = document.querySelector(
      "#menu-drawer .menu-drawer__utility-links",
    );

    if (navigation) navigation.classList.add("hidden");
    if (utilityLinks) utilityLinks.classList.add("hidden");

    this.classList.add("open");
  }

  productBadge(item, index) {
    const obj = item.customFields?.find(
      (field) => field.key === "custom-product_badge_json",
    );
    if (!obj) return "";

    const elementClass = `.badge-index-${index}`;
    const badges = JSON.parse(obj.value);

    if (badges.text && badges.color) {
      return `<span class="${elementClass}" style="color: ${badges.color};">${badges.text}</span>`;
    } else if (badges.text) {
      return badges.text;
    }
    return "";
  }

  getCustomPrivateSaleDiscountPrice(product) {
    const currencyCodeToKeyMap = {
      GB: "custom-private_sale_discount_price",
      EU: "custom-private_sale_discount_price_eu",
      USA: "custom-private_sale_discount_price_us",
      "AUSTRALIA-NEW-ZEALAND": "custom-private_sale_discount_price_au",
      UAE: "custom-private_sale_discount_price_uae",
      ROW: "custom-private_sale_discount_price",
      THAILAND: "custom-private_sale_discount_price_th",
      SWITZERLAND: "custom-private_sale_discount_price_ch",
    };

    const key =
      currencyCodeToKeyMap[window.localizationMarketHandle.toUpperCase()];
    if (key) {
      return getCustomField(product, key) ?
          parseInt(getCustomField(product, key))
        : product.price;
    }
    return product.price;
  }

  getPriceSpan(product) {
    if (
      (window.privateSale || window.initialPrivateSaleAccess) &&
      this.getCustomPrivateSaleDiscountPrice(product) < product.price
    ) {
      return `<span class="pricing-product_standard_price ${product.priceCurrencyCode}" title="Standard Price">${product.price}</span>
              <span class="sale pricing-product_sales_price ${product.priceCurrencyCode}" title="Sale Price">${this.getCustomPrivateSaleDiscountPrice(product)}</span>`;
    } else {
      if (product.listPrice > product.price) {
        return `<span class="pricing-product_standard_price ${product.priceCurrencyCode}" title="Standard Price">${product.listPrice}</span>
                <span class="sale pricing-product_sales_price ${product.priceCurrencyCode}" title="Sale Price">${product.price}</span>`;
      } else {
        return `<span class="pricing-product_sales_price ${product.priceCurrencyCode}" title="Sale Price">${product.price}</span>`;
      }
    }
  }
}

// Function to get custom field value from product
function getCustomField(product, fieldName) {
  if (!product.customFields) return "";
  const customField = product.customFields.find(
    (field) => field.key === fieldName,
  );
  return customField ? customField.value : "";
}

if (!customElements.get("mobile-search")) {
  customElements.define("mobile-search", MobileSearch);
}
